const mixin = {
  methods: {
    changeTab (tab) {
      this.selected = tab
    },
    setting () {
      this.showSetMask = true
    },
    hideSetMask () {
      this.showSetMask = false
    },
    pushRouter (path) {
      this.$router.push({ path: path })
    },
    back () {
      this.$router.back()
    },
    logout () {
      this.$router.push({ path: 'login' })
    }
  }
}

export default mixin
